const production = true;

export const apiUrl = production
  ? "https://api-nec.nesieyecare.com"
  : "http://localhost:5012";
